<div class="clr-row">
  <div class="clr-col-12">
    <a [routerLink]="postLink" class="card clickable clr-row p-3">
      <div class="card-img clr-col-12 clr-col-md-4 px-2"
           [style.backgroundImage]="postImage"
      >
      </div>
      <div class="card-block clr-col-12 clr-col-md-8">
        <div class="card-title"><h2 [innerHTML]="postData.title.rendered"></h2></div>
        <div class="card-tags">
          <span class="tag mr-1 py-1 px-2" *ngFor="let category of postData.parsedCategories">{{category}}</span>
          <div>
          <button class="activity-button">
            <fa-icon icon="play"></fa-icon>
          </button>
        </div>
        </div>
        <p class="card-text" [innerHTML]="postData.excerpt.rendered">
        </p>
      </div>
    </a>
  </div>
</div>
